module.exports = __webpack_public_path__ + "img/lead-web.6a5ac9e3.png";